import { render, staticRenderFns } from "./DisableStudent.vue?vue&type=template&id=7f67755f&scoped=true&"
import script from "./DisableStudent.vue?vue&type=script&lang=js&"
export * from "./DisableStudent.vue?vue&type=script&lang=js&"
import style0 from "./DisableStudent.vue?vue&type=style&index=0&id=7f67755f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f67755f",
  null
  
)

export default component.exports